// extracted by mini-css-extract-plugin
export default {"wrapper":"CompanyDetailPanel_wrapper__RUHeH","panel":"CompanyDetailPanel_panel__439ke","detail":"CompanyDetailPanel_detail__99k0U"};